import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    jobGrades: [],
    jobGrade: {},
    totalItems:0,

};

const getters = {
    index: state => jobGradeId => state.jobGrades.findIndex(i => i.jobGradeId === jobGradeId)
};

const mutations = {
    setJobGrades: (state, r) => (state.jobGrades = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    add: (state, r) => state.jobGrades.unshift(r),
    delete: (state, index) => state.jobGrades.splice(index, 1),
    lock: (state, index) => state.jobGrades[index].status = status.locked,
    unlock: (state, index) => state.jobGrades[index].status = status.active,
    setJobGrade: (state, r) => (state.jobGrade = r),
    edit: (state, { index, r }) => state.jobGrades.splice(index, 1, r),

};

const actions = {
    async getAll({ commit } , params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.jobGrades.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setJobGrades", response.data.jobGrades);
            commit("setTotalItems", response.data.totalItems);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },

    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.jobGrades.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.jobGrade);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.jobGrades.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setJobGrade", {});
            console.log(id)
            startLoading()
            const response = await dataService.jobGrades.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setJobGrade", response.data.jobGrade);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.jobGrades.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.jobGrade);
        
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.jobGrades.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
            showNotification(response.data.message);

            const index = getters.index(id);
            commit("edit", { index, r: response.data.jobGrade });

            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
